import React from 'react';
import {Formik, Form} from 'formik';
import * as Yup from 'yup';
import classnames from 'classnames';
import FieldInput from '../FieldInput';
import {errors as E} from 'common/constants/errors';
import styles from './styles.module.scss';

const FormPreviewLite = ({
                           imageSrc,
                           formInitialValues,
                           onConfirm,
                           onReject,
                         }) => {
  const handleSubmit = (values) => {
    if (onConfirm) onConfirm({freeText: values.freeText ?? ''});
  };

  return (
    <div className={styles.previewContainer}>
      <div className={styles.modalApiImage}>
        {imageSrc && (
          <img src={imageSrc} alt="content" className={styles.image}/>
        )}
      </div>
      <Formik
        initialValues={{freeText: formInitialValues?.freeText ?? ''}}
        onSubmit={handleSubmit}
        validationSchema={Yup.object().shape({freeText: Yup.string().required(E.REQUIRED_FIELD)})}
        enableReinitialize={true}
      >
        {({values}) => (
          <Form>
            <div className={classnames(styles.formContainer, styles.centeredContent)}>
                <FieldInput
                  fieldId="freeText"
                  type={'text'}
                  value={values.freeText}
                  label={(
                    <div>
                      <span className={styles.mandatoryMark}>*</span>
                      כותרת לתמונה
                    </div>
                  )}
                />
            </div>
            <div className={styles.modalButtons}>
              <button
                type="button"
                className={styles.buttonCancel}
                onClick={onReject}
              >
                <span>ביטול</span>
              </button>
              <button
                type="submit"
                className={styles.buttonSubmit}
              >
                <span>אשר והוסף לשומה</span>
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default FormPreviewLite;